import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';

export function withRouter(Component: any) {
    const Wrapper = (props: any) => {
        const location = useLocation();
        const navigate = useNavigate();
        const [urlParams] = useSearchParams();
        const params = useParams();

        return <Component navigate={navigate} params={params} location={location} urlParams={urlParams} {...props} />;
    };

    return Wrapper;
}
